/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Training_Setup_TitleInputs */

const en_training_setup_title = /** @type {(inputs: Training_Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set up your training`)
};

const pl_training_setup_title = /** @type {(inputs: Training_Setup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ustaw swój trening`)
};

/**
* | output |
* | --- |
* | "Set up your training" |
*
* @param {Training_Setup_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const training_setup_title = /** @type {((inputs?: Training_Setup_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Training_Setup_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_training_setup_title(inputs)
	return en_training_setup_title(inputs)
});